export default (theme) => {
  return `
    .mu-avatar {
      background-color: ${theme.track};
      color: ${theme.text.alternate};
    }
  `;
};




// WEBPACK FOOTER //
// ./src/muse-ui/Avatar/theme.js